import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {Link} from "react-router-dom";
import moment from "moment/moment";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import './style.scss'
import ModalLoading from "../../../components/common/ModalLoading";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ review }) => ({ getReviewList:review.getReviewList,
  updateReviewDisplayStatus: review.updateReviewDisplayStatus,
  adminDelReview:review.adminDelReview,
  removeReviewMany:review.removeReviewMany }))

@observer
class ReviewMassList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable isLogin = false;
  @observable isLoading = true;

  //page
  @observable searchFormValue = {
    searchType: 'all',
    keyword: '',
    dateType: 'createdAt',
    startDate: '',
    endDate: '',
  };

  @observable starFilter = {
    all: true,
    star1: false,
    star2: false,
    star3: false,
    star4: false,
    star5: false,
  };

  @observable listParams = {
    page: 1,
    limit: 20
  };

  @observable list = {
    docs: [],
    totalDocs: 0,
    page: 1,
    totalPages: 1
  };

  @observable selectedReviews = [];
  @observable isAllSelected = false;

  componentDidMount() {
    this.init();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.listParams.limit = parseInt(await Storage.get('limitReviewMassList')) || this.listParams.limit;
      await this.doSearch();
    }
  };

  @action
  doSearch = async (type) => {
    let _this = this;
    _this.isLoading = true;
    Storage.set('limitReviewMassList', _this.listParams.limit);

    let searchParams = { fromWrite: 'file', displayAt: 'all' };

    if(_this.searchFormValue.keyword) {
      searchParams.keyword = _this.searchFormValue.keyword;
      searchParams.searchType = _this.searchFormValue.searchType;
    }
    if(_this.searchFormValue.startDate) {
      searchParams.startDate = _this.searchFormValue.startDate;
      searchParams.dateType = _this.searchFormValue.dateType;
    }
    if(_this.searchFormValue.endDate) {
      searchParams.endDate = _this.searchFormValue.endDate;
      searchParams.dateType = _this.searchFormValue.dateType;
    }

    // 별점 필터
    if(!_this.starFilter.all) {
      searchParams.star = { ..._this.starFilter };
    }

    let params = {
      store_id: _this.store._id,
      shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
      page: _this.listParams.page,
      limit: _this.listParams.limit,
      searchParams: searchParams
    };

    this.props.getReviewList(params, function(res) {
      if(res && res.docs) {
        _this.list = res;
      }
      _this.isLoading = false;
    });
  };

  @action
  onChangeSearchValue = async (event) => {
    const { name, value } = event.target;
    this.searchFormValue[name] = value;
  };

  @action
  onKeyPressSearch = (event) => {
    if(event.key === 'Enter') {
      this.listParams.page = 1;
      this.doSearch();
    }
  };

  @action
  toggleStarFilter = (key) => {
    if (key === 'all') {
      this.starFilter = { all: true, star1: false, star2: false, star3: false, star4: false, star5: false };
    } else {
      this.starFilter = { ...this.starFilter, [key]: !this.starFilter[key], all: false };
      const anyActive = ['star1','star2','star3','star4','star5'].some(k => this.starFilter[k]);
      if (!anyActive) {
        this.starFilter = { all: true, star1: false, star2: false, star3: false, star4: false, star5: false };
      }
    }
    this.listParams.page = 1;
    this.doSearch();
  };

  getStarRating = (score) => {
    const stars = Math.min(Math.floor((score || 0) / 20), 5);
    return '\u2605'.repeat(stars) + '\u2606'.repeat(5 - stars);
  };

  @action
  deleteReview = async (review) => {
    if(!window.confirm('정말로 삭제하시겠습니까?')) return;
    let _this = this;
    _this.isLoading = true;
    this.props.adminDelReview({
      review_id: review._id,
      store_id: _this.store._id
    }, function(res) {
      if(res && !res.errors) {
        toast.success('리뷰가 삭제되었습니다.');
        _this.doSearch();
      } else {
        toast.error('리뷰 삭제 중 오류가 발생했습니다.');
      }
      _this.isLoading = false;
    });
  };

  @action
  updateDisplayStatus = async (review, status) => {
    let _this = this;
    _this.isLoading = true;
    this.props.updateReviewDisplayStatus({
      review_id: review._id,
      displayStatus: status
    }, function(res) {
      if(res && !res.errors) {
        review.displayStatus = status;
        toast.success('게시 상태가 변경되었습니다.');
      } else {
        toast.error('상태 변경 중 오류가 발생했습니다.');
      }
      _this.isLoading = false;
    });
  };

  @action
  toggleSelectAll = () => {
    if (this.isAllSelected) {
      this.selectedReviews = [];
      this.isAllSelected = false;
    } else {
      this.selectedReviews = this.list.docs.map(item => item._id);
      this.isAllSelected = true;
    }
  };

  @action
  toggleSelectReview = (reviewId) => {
    const index = this.selectedReviews.indexOf(reviewId);
    if (index > -1) {
      this.selectedReviews.splice(index, 1);
    } else {
      this.selectedReviews.push(reviewId);
    }
    this.isAllSelected = this.selectedReviews.length === this.list.docs.length;
  };

  @action
  deleteSelectedReviews = async () => {
    if (this.selectedReviews.length === 0) {
      toast.warning('삭제할 리뷰를 선택해주세요.');
      return;
    }
    if (!window.confirm(`선택한 ${this.selectedReviews.length}개의 리뷰를 삭제하시겠습니까?`)) return;
    let _this = this;
    _this.isLoading = true;
    this.props.removeReviewMany({
      store_id: _this.store._id,
      isWriteFile: true,
      review_ids: _this.selectedReviews
    }, function(res) {
      if(res && !res.errors) {
        toast.success(`${_this.selectedReviews.length}개의 리뷰가 삭제되었습니다.`);
        _this.selectedReviews = [];
        _this.isAllSelected = false;
        _this.doSearch();
      } else {
        toast.error('리뷰 삭제 중 오류가 발생했습니다.');
      }
      _this.isLoading = false;
    });
  };

  render() {
    let _this = this;
    const totalDocs = this.list.totalDocs || 0;
    const curPage = this.list.page || 1;
    const totalPages = this.list.totalPages || 1;
    const limit = this.list.limit || 20;

    const PaginationNav = () => {
      if (!totalPages || totalPages < 1) return null;
      const startNum = Math.floor((curPage - 1) / 10) * 10 + 1;
      const endNum = Math.min(startNum + 9, totalPages);
      const pages = [];
      for (let i = startNum; i <= endNum; i++) pages.push(i);

      return (
        <nav className="rmw-pagination" aria-label="페이지 탐색">
          {curPage > 1 && (
            <button type="button" className="rmw-pagination__btn" onClick={() => { _this.listParams.page = 1; _this.doSearch(); }} aria-label="첫 페이지">
              <FeatherIcon icon="chevrons-left" size={14} />
            </button>
          )}
          {startNum > 1 && (
            <button type="button" className="rmw-pagination__btn" onClick={() => { _this.listParams.page = startNum - 1; _this.doSearch(); }} aria-label="이전 10페이지">
              <FeatherIcon icon="chevron-left" size={14} />
            </button>
          )}
          {pages.map(p => (
            <button
              key={p}
              type="button"
              className={`rmw-pagination__num${p === curPage ? ' is-active' : ''}`}
              onClick={() => { _this.listParams.page = p; _this.doSearch(); }}
              aria-current={p === curPage ? 'page' : undefined}
            >{p}</button>
          ))}
          {endNum < totalPages && (
            <button type="button" className="rmw-pagination__btn" onClick={() => { _this.listParams.page = endNum + 1; _this.doSearch(); }} aria-label="다음 10페이지">
              <FeatherIcon icon="chevron-right" size={14} />
            </button>
          )}
          {curPage < totalPages && (
            <button type="button" className="rmw-pagination__btn" onClick={() => { _this.listParams.page = totalPages; _this.doSearch(); }} aria-label="마지막 페이지">
              <FeatherIcon icon="chevrons-right" size={14} />
            </button>
          )}
        </nav>
      );
    };

    const STAR_OPTIONS = [
      { key: 'all', label: '전체' },
      { key: 'star5', label: '\u2605\u2605\u2605\u2605\u2605', score: '5점' },
      { key: 'star4', label: '\u2605\u2605\u2605\u2605\u2606', score: '4점' },
      { key: 'star3', label: '\u2605\u2605\u2605\u2606\u2606', score: '3점' },
      { key: 'star2', label: '\u2605\u2605\u2606\u2606\u2606', score: '2점' },
      { key: 'star1', label: '\u2605\u2606\u2606\u2606\u2606', score: '1점' },
    ];

    return (
      <div className="main-content rmw-page">
        <PageTitle />

        {/* 헤더 */}
        <div className="rmw-header">
          <div className="rmw-header__title-area">
            <h1 className="rmw-header__title">대량 등록 리뷰 관리</h1>
            <p className="rmw-header__subtitle">대량 등록된 리뷰를 검색, 관리할 수 있습니다.</p>
          </div>
          <div className="rmw-header__actions">
            <Link to="/reviewMassWrite">
              <button type="button" className="rmw-btn rmw-btn--primary">
                <FeatherIcon icon="upload" size={16} />
                <span>대량 등록하기</span>
              </button>
            </Link>
          </div>
        </div>

        {/* 검색 섹션 */}
        <section className="rmw-section">
          <div className="rml-search">
            <div className="rml-search__row">
              <div className="rml-search__field">
                <label className="rml-search__label">검색 구분</label>
                <select
                  className="rmw-select"
                  name="searchType"
                  value={this.searchFormValue.searchType}
                  onChange={e => this.onChangeSearchValue(e)}
                >
                  <option value="review">리뷰내용</option>
                  <option value="name">작성자</option>
                  <option value="productName">상품명</option>
                  <option value="platformProductId">상품번호</option>
                </select>
              </div>
              <div className="rml-search__field rml-search__field--grow">
                <label className="rml-search__label">검색어</label>
                <input
                  className="rml-search__input"
                  type="text"
                  name="keyword"
                  placeholder="검색어를 입력하세요"
                  value={this.searchFormValue.keyword}
                  onChange={e => this.onChangeSearchValue(e)}
                  onKeyPress={e => this.onKeyPressSearch(e)}
                />
              </div>
              <div className="rml-search__field">
                <label className="rml-search__label">날짜 구분</label>
                <select
                  className="rmw-select"
                  name="dateType"
                  value={this.searchFormValue.dateType}
                  onChange={e => this.onChangeSearchValue(e)}
                >
                  <option value="createdAt">생성날짜</option>
                  <option value="writerAt">작성날짜</option>
                </select>
              </div>
              <div className="rml-search__field">
                <label className="rml-search__label">시작일</label>
                <input
                  className="rml-search__input"
                  type="date"
                  name="startDate"
                  value={this.searchFormValue.startDate}
                  onChange={e => this.onChangeSearchValue(e)}
                />
              </div>
              <div className="rml-search__field">
                <label className="rml-search__label">종료일</label>
                <input
                  className="rml-search__input"
                  type="date"
                  name="endDate"
                  value={this.searchFormValue.endDate}
                  onChange={e => this.onChangeSearchValue(e)}
                />
              </div>
            </div>

            {/* 별점 필터 */}
            <div className="rml-search__row rml-search__row--stars">
              <span className="rml-search__label rml-search__label--inline">별점</span>
              <div className="rml-star-filter" role="group" aria-label="별점 필터">
                {STAR_OPTIONS.map(opt => (
                  <button
                    key={opt.key}
                    type="button"
                    className={`rml-star-filter__btn${this.starFilter[opt.key] ? ' is-active' : ''}`}
                    onClick={() => this.toggleStarFilter(opt.key)}
                    aria-pressed={this.starFilter[opt.key]}
                  >
                    {opt.key === 'all' ? (
                      <span>전체</span>
                    ) : (
                      <>
                        <span className="rml-star-filter__stars">{opt.label}</span>
                        <span className="rml-star-filter__score">{opt.score}</span>
                      </>
                    )}
                  </button>
                ))}
              </div>
              <button
                type="button"
                className="rmw-btn rmw-btn--primary rmw-btn--sm"
                style={{marginLeft: 'auto'}}
                onClick={() => { this.listParams.page = 1; this.doSearch(); }}
              >
                <FeatherIcon icon="search" size={14} />
                검색
              </button>
            </div>
          </div>
        </section>

        {/* 테이블 섹션 */}
        <section className="rmw-section" style={{padding: 0, overflow: 'hidden'}}>
          {/* 상단 바 */}
          <div className="rml-toolbar">
            <div className="rml-toolbar__info">
              <strong>전체 {totalDocs}건</strong>
              {this.selectedReviews.length > 0 && (
                <button
                  type="button"
                  className="rmw-btn rmw-btn--danger rmw-btn--sm"
                  onClick={() => this.deleteSelectedReviews()}
                >
                  <FeatherIcon icon="trash-2" size={14} />
                  선택 삭제 ({this.selectedReviews.length})
                </button>
              )}
            </div>
            <select
              className="rmw-select rml-toolbar__limit"
              value={this.listParams.limit}
              onChange={e => {
                this.listParams.limit = parseInt(e.target.value);
                this.listParams.page = 1;
                Storage.set('limitReviewMassList', e.target.value);
                this.doSearch();
              }}
            >
              <option value="20">20개씩</option>
              <option value="50">50개씩</option>
              <option value="100">100개씩</option>
              <option value="300">300개씩</option>
              <option value="500">500개씩</option>
            </select>
          </div>

          {/* 데이터 테이블 */}
          <div className="rmw-table-wrap">
            <table className="rmw-data-table rml-table" aria-label="대량 등록 리뷰 목록">
              <colgroup>
                <col style={{width:'40px'}} />
                <col style={{width:'50px'}} />
                <col style={{width:'90px'}} />
                <col style={{width:'14%'}} />
                <col />
                <col style={{width:'10%'}} />
                <col style={{width:'9%'}} />
                <col style={{width:'10%'}} />
                <col style={{width:'10%'}} />
                <col style={{width:'8%'}} />
                <col style={{width:'100px'}} />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">
                    <input
                      type="checkbox"
                      checked={this.isAllSelected}
                      onChange={() => this.toggleSelectAll()}
                      aria-label="전체 선택"
                    />
                  </th>
                  <th scope="col">#</th>
                  <th scope="col">상품번호</th>
                  <th scope="col">상품명</th>
                  <th scope="col">리뷰내용</th>
                  <th scope="col">작성자</th>
                  <th scope="col">평점</th>
                  <th scope="col">작성날짜</th>
                  <th scope="col">생성날짜</th>
                  <th scope="col">게시상태</th>
                  <th scope="col">관리</th>
                </tr>
              </thead>
              <tbody>
                {this.list.docs && this.list.docs.length > 0 ? (
                  this.list.docs.map((item, i) => {
                    const rowNum = totalDocs - ((curPage - 1) * limit) - i;
                    return (
                      <tr key={item._id || i} className="rmw-data-row">
                        <td className="rmw-data-row__cell rmw-data-row__cell--checkbox">
                          <input
                            type="checkbox"
                            checked={this.selectedReviews.includes(item._id)}
                            onChange={() => this.toggleSelectReview(item._id)}
                          />
                        </td>
                        <td className="rmw-data-row__cell rmw-data-row__cell--num">{rowNum}</td>
                        <td className="rmw-data-row__cell" style={{textAlign:'center', fontFamily:'SFMono-Regular,Menlo,monospace', fontSize:'12px'}}>
                          {item.platformProductId || '-'}
                        </td>
                        <td className="rmw-data-row__cell" style={{textAlign:'left'}}>
                          <div className="rml-cell-product">
                            {item.orderProductName || (item.product_id && typeof item.product_id === 'object' && item.product_id.productName) || '-'}
                          </div>
                        </td>
                        <td className="rmw-data-row__cell" style={{textAlign:'left'}}>
                          <div className="rml-cell-contents">
                            {item.contents ? item.contents.replace(/<[^>]*>/g, '').slice(0, 80) : '-'}
                          </div>
                        </td>
                        <td className="rmw-data-row__cell" style={{textAlign:'center'}}>{item.writerName || '-'}</td>
                        <td className="rmw-data-row__cell" style={{textAlign:'center'}}>
                          <span className="rmw-stars" title={item.goodsPt ? `${item.goodsPt}점` : ''}>
                            {item.goodsPt ? this.getStarRating(item.goodsPt) : '-'}
                          </span>
                        </td>
                        <td className="rmw-data-row__cell rmw-data-row__cell--date">
                          {item.writerAt ? moment(item.writerAt).format('YYYY-MM-DD HH:mm') : '-'}
                        </td>
                        <td className="rmw-data-row__cell rmw-data-row__cell--date">
                          {item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '-'}
                        </td>
                        <td className="rmw-data-row__cell rmw-data-row__cell--status">
                          {item.displayStatus === 2 ? (
                            <span className="rmw-badge rmw-badge--success">게시중</span>
                          ) : item.displayStatus === 1 ? (
                            <span className="rmw-badge rmw-badge--warning">대기</span>
                          ) : (
                            <span className="rmw-badge rmw-badge--danger">미게시</span>
                          )}
                        </td>
                        <td className="rmw-data-row__cell rmw-data-row__cell--action">
                          <div className="rml-actions">
                            {item.displayStatus !== 2 ? (
                              <button type="button" className="rmw-icon-btn" onClick={() => this.updateDisplayStatus(item, 2)} title="게시" aria-label="게시">
                                <FeatherIcon icon="eye" size={14} />
                              </button>
                            ) : (
                              <button type="button" className="rmw-icon-btn" onClick={() => this.updateDisplayStatus(item, 3)} title="미게시" aria-label="미게시">
                                <FeatherIcon icon="eye-off" size={14} />
                              </button>
                            )}
                            <button type="button" className="rmw-icon-btn rmw-icon-btn--danger" onClick={() => this.deleteReview(item)} title="삭제" aria-label="삭제">
                              <FeatherIcon icon="trash-2" size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="11" style={{textAlign:'center', padding:'48px 24px', color:'#94A3B8'}}>
                      <FeatherIcon icon="inbox" size={40} style={{marginBottom:'12px', display:'block', margin:'0 auto 12px'}} />
                      대량 등록된 리뷰가 없습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 페이지네이션 */}
          <div className="rml-pagination-wrap">
            <PaginationNav />
          </div>
        </section>

        <ModalLoading isLoading={this.isLoading} />
      </div>
    );
  }
}

export default ReviewMassList;
